var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.184,
    height: 53,
    viewBox: "0 0 76.184 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45074",
    "data-name": "Path 45074",
    d: "M0,19.5v-.744L7.29,8.907l.746-.488L38.168,0,68.56,8.608,75.8,18.18a1.28,1.28,0,0,1-.4,2.1l-6.334,2.3-.1,17.461A5.03,5.03,0,0,1,66.809,41.3C57.425,45.491,47.635,49.036,38.17,53l-.674-.087L7.665,40.485l-.445-.448-.1-17.461L.892,20.324ZM63.093,9.537l-25.068-7L13.094,9.609l25.052,6.869ZM35.862,18.465,8.868,11.047,3.277,18.389,28.791,27.1Zm4.465,0L47.4,27.1l25.514-8.708-5.591-7.342ZM36.9,21.439c-.351-.094-.252.092-.34.191-2.014,2.254-3.79,5.067-5.833,7.252-.39.417-.877,1.006-1.488,1.015L9.672,23.374V38.626L36.9,49.861Zm2.381,0V49.861L66.516,38.626V23.374L46.946,29.9c-.61-.009-1.1-.6-1.488-1.015-2.044-2.185-3.819-5-5.833-7.252-.088-.1.011-.285-.34-.191",
    fill: "#ef7b13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.e7e0b4a27cae6f3d497d09ab57addea4.svg";
export { ForwardRef as ReactComponent };